export const queryKeys = {
  session: () => ["session"] as const,
  organizations: () => ["organizations"] as const,
};
